import React from 'react'
import { twMerge } from 'tailwind-merge'
import { useCookie } from 'msp-integrations'
import { Icons } from 'msp-components'
import { IconButtonProps } from './IconButton.types'

const IconButton = ({
  className,
  onClick,
  iconName,
  height,
  width,
  color,
  event_name = '',
  event_action = '',
  notSelectable = false,
  ariaLabel
}: IconButtonProps) => {
  const { eventTracking } = useCookie()
  const handleClick = () => {
    if (event_name && event_action) {
      eventTracking(event_name, { event_action: event_action })
    }
    onClick && onClick()
  }
  const selectable = notSelectable ? { tabIndex: -1 } : {}

  return (
    <button
      className={twMerge('flex cursor-pointer items-center', className)}
      onClick={() => handleClick()}
      aria-label={ariaLabel ?? iconName}
      {...selectable}
    >
      <Icons iconName={iconName} height={height} width={width} color={color} />
    </button>
  )
}

export default IconButton
